/**
 * Shared types for InBody Composition components
 */
export enum DisplayMode {
    Kg = 'kg',
    Percentage = 'percentage',
    Both = 'both',
}

export enum Units {
    Kg = 'kg',
    L = 'L',
    Percent = '%',
}

export enum BodyCompositionStatus {
    Low = 'low',
    Average = 'average',
    High = 'high',
}
export interface InbodyOverallData {
    weightKg?: number;
    bodyFatMassKg?: number;
    fatFreeMassKg?: number;
    skeletalMuscleMassKg?: number;
    totalBodyWater?: number;
    bodyFatPercentage?: number;
}

export interface InbodySegmentalData {
    ffmOfRightArmKg?: number;
    ffmOfRightArmPercentage?: number;
    ffmOfLeftArmKg?: number;
    ffmOfLeftArmPercentage?: number;
    ffmOfTrunkKg?: number;
    ffmOfTrunkPercentage?: number;
    ffmOfRightLegKg?: number;
    ffmOfRightLegPercentage?: number;
    ffmOfLeftLegKg?: number;
    ffmOfLeftLegPercentage?: number;
}
